export default __webpack_public_path__ + "static/media/StrikezoneHunterCover.e5c00a81.png";